import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useRoutes } from '../../hooks/useRoutes';
import RoutesDashboard from '../../components/administracion/rutas/RoutesDashboard';

const RutasPage = () => {
  const { routes, error, isLoading } = useRoutes();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar rutas.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <RoutesDashboard
        windows={routes}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de rutas:', newOrder);
        }}
      />
    </Box>
  );
};

export default RutasPage;